import React from 'react';
import { useDispatch } from 'react-redux';
import { updateShowSetMinDurationsModal } from '../../../../actions/modal';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { Icon, Message } from 'semantic-ui-react';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);
// This component represents the whole right hand side panel on Desktop;
// And represents the top panel above center panel on Mobile/Tablet
export default function RightPanelOrTopPanel(props) {
  const dispatch = useDispatch();
  const minConsultationDur = (props.minConsultationDurValue / 60).toFixed(1);
  const minMeetingDur = (props.minMeetingDurValue / 60).toFixed(1);

  const setMinDurations = () => {
    if (props.fetchingReports) {
      return;
    }
    dispatch(updateShowSetMinDurationsModal(true));
  };

  const renderDataOutOfDateWarning = (isOnMobileOrTablet) => {
    if (isOnMobileOrTablet) {
      let warningClass = 'borderless bg-transparent pdlnull pdrnull color-warning';
      return (
        <Message icon className={warningClass}>
          <Icon name="exclamation circle" className="mrrs" />
          <Message.Content>
            <div className="color-info">
              <span>
                <div className="left-text"> {APP.LANGUAGE.MainReport.OutOfDateWarning} </div>
              </span>
            </div>
          </Message.Content>
        </Message>
      );
    }

    let warningClass =
      'borderless bg-transparent pdlnull pdrnull color-warning top-with-flex pdlxl pdrxl pdtnull mrtnull';
    return (
      <Message icon className={warningClass}>
        <Icon name="exclamation circle" className="mrrs" />
        <Message.Content>
          <div className="color-info">
            <span>
              <div className="left-text"> {APP.LANGUAGE.MainReport.OutOfDateWarning} </div>
            </span>
          </div>
        </Message.Content>
      </Message>
    );
  };

  const setMinDurationsButton = (
    <button
      className="ui icon button set-duration-trim-btn hide-on-large-device"
      onClick={setMinDurations}
      style={{ cursor: props.fetchingReports ? 'default' : 'pointer' }}
    >
      <Icon name="wait" style={{ marginTop: '-2px' }} />
    </button>
  );

  return (
    <div style={{ height: '100%' }}>
      <Container fluid as={Media} greaterThanOrEqual="computer" style={{ height: '100%' }}>
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdtxl pdbm pdrm logo-on-right-hand">
            <img className="ui image pdtxs umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo.default} />
            <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo.default} />
          </div>
          <div>
            <div className="color-white-bg pdtm pdll pdrm">
              <div className="instructions-flex-container">
                <div className="instructions-container">
                  <div
                    className="mrrm instructions"
                    onClick={setMinDurations}
                    style={{
                      cursor: props.fetchingReports ? 'default' : 'pointer',
                    }}
                  >
                    <img className="instruction-img" src={APP.IMAGES.WaitingAreaIcon.default} />
                    <span className="instruction-label">
                      {htmlToReactParser.parse(
                        xss(
                          APP.LANGUAGE.MainReport.MinConsultationDur.replace(
                            '##minConsultationDur##',
                            minConsultationDur
                          )
                        )
                      )}
                    </span>
                  </div>
                  <div
                    className="mrrm instructions"
                    onClick={setMinDurations}
                    style={{
                      cursor: props.fetchingReports ? 'default' : 'pointer',
                    }}
                  >
                    <img className="instruction-img" src={APP.IMAGES.MeetingRoomIcon.default} />
                    <span className="instruction-label">
                      {htmlToReactParser.parse(
                        xss(APP.LANGUAGE.MainReport.MinMeetingDur.replace('##minMeetingDur##', minMeetingDur))
                      )}
                    </span>
                  </div>
                </div>
                <div className="clear" />
                <div className="flex-button-container">{setMinDurationsButton}</div>
              </div>
            </div>
            <div className="pdbm pdrl pdll">{props.bottomSession}</div>
            {props.hideDataOutdateWarning ? '' : renderDataOutOfDateWarning(false)}
          </div>
        </div>
      </Container>
      <Container fluid as={Media} lessThan="computer">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="color-white-bg pdbm pdlm pdrm">
            <div className="instructions-flex-container">
              <div className="instructions-container">
                <div
                  className="mrrm instructions"
                  onClick={setMinDurations}
                  style={{
                    cursor: props.fetchingReports ? 'default' : 'pointer',
                  }}
                >
                  <img className="instruction-img" src={APP.IMAGES.WaitingAreaIcon.default} />
                  <span
                    className="instruction-label"
                    dangerouslySetInnerHTML={{
                      __html: APP.LANGUAGE.MainReport.MinConsultationDur.replace(
                        '##minConsultationDur##',
                        minConsultationDur
                      ),
                    }}
                  />
                </div>
                <div
                  className="mrrm instructions"
                  onClick={setMinDurations}
                  style={{
                    cursor: props.fetchingReports ? 'default' : 'pointer',
                  }}
                >
                  <img className="instruction-img" src={APP.IMAGES.MeetingRoomIcon.default} />
                  <span
                    className="instruction-label"
                    dangerouslySetInnerHTML={{
                      __html: APP.LANGUAGE.MainReport.MinMeetingDur.replace('##minMeetingDur##', minMeetingDur),
                    }}
                  />
                </div>
              </div>
              <div className="clear mrbm" />
              <div className="flex-button-container">{setMinDurationsButton}</div>
            </div>
            {props.hideDataOutdateWarning ? '' : renderDataOutOfDateWarning(true)}
          </div>
        </div>
      </Container>
    </div>
  );
}
